import { render, staticRenderFns } from "./ListPosts.vue?vue&type=template&id=18228b4c&"
import script from "./ListPosts.vue?vue&type=script&lang=js&"
export * from "./ListPosts.vue?vue&type=script&lang=js&"
import style0 from "./ListPosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports